export default [
    {
        path: '/solution',
        name: 'Solution',
        component: () => import('../../views/Solution.vue')
    }
]
